import request from '@/utils/request'
import { $t } from '@/i18n'

// 商品库列表
export function goodsList(params) {
  return request({
    url: '/goods/v1',
    params
  })
}

// 断品商品库列表
export function goodsDpList(params) {
  return request({
    url: '/goods/dp/v1',
    params
  })
}


// 组织商品库列表
export function orgGoodsList(params) {
  return request({
    url: '/mgt_org_goods/v1',
    params
  })
}

// 商品批量启用禁用
export function batchEnabled(data) {
  return request({
    url: '/goods/enabled_id_list/v1',
    method: 'PUT',
    data
  })
}

// 商品价格修改
export function editGoods(id, data) {
  return request(
    {
      url: `/goods/${ id }/v1`,
      method: 'PUT',
      data
    },
    {
      success: true,
      successMsg: $t('constant.editSuccessful')
    }
  )
}

// 商品中心列表
export function goodsCenterList(params) {
  return request({
    url: '/goods_center/v2',
    params
  })
}

// 添加到我的商品库
export function addGoodsToLibrary(data) {
  return request(
    {
      url: '/goods_center/v1',
      method: 'POST',
      data
    },
    {
      success: true,
      successMsg: $t('constant.addedSuccessfully')
    }
  )
}

// 商品申请新增
export function addVerifyGoods(data) {
  return request(
    {
      url: '/goods_apply/v1',
      method: 'POST',
      data
    },
    {
      success: true,
      successMsg: $t('common.operatorOK')
    }
  )
}

// 驳回商品重新申请
export function againVerifyGoods(id, data) {
  return request(
    {
      url: `/goods_apply/${ id }/v1`,
      method: 'PUT',
      data
    },
    {
      success: true,
      successMsg: $t('common.operatorOK')
    }
  )
}

// 商品申请列表
export function goodsVerifyList(params) {
  return request({
    url: '/goods_apply/v1',
    params
  })
}

// 撤回商品申请
export function withdrawVerifyGoods(id, data) {
  return request(
    {
      url: `/goods_apply/${ id }/withdraw/v1`,
      method: 'PUT',
      data
    },
    {
      success: true,
      successMsg: $t('common.operatorOK')
    }
  )
}

// 审核商品详情
export function getGoodsVerifyInfo(id) {
  return request({
    url: `/goods_apply/${ id }/v1`
  })
}


// 所有商品查询
export function getAllGoodsList(params) {
  return request({
    url: '/goods/v2',
    params
  })
}

/*虚拟商品*/

//虚拟商品列表查询
export function getVirtualGoodsList(params) {
  return request({
    url: '/goods/unreal/v1',
    params
  })
}

//新增虚拟商品
export function addVirtualGoodsList(data) {
  return request({
    url: '/goods/unreal/insert',
    method: 'POST',
    data
  })
}

//根据Id查询虚拟商品详情
export function getVirtualGoodsDetailsById(id) {
  return request({
    url: `/goods/unreal/${ id }`
  })
}

//删除
export function deleteVirtualGoods(id) {
  return request({
    url: `/goods/unreal/delete/${ id }`,
    method: 'DELETE'
  })
}

//虚拟商品发放
export function sendVirtualGoods(data) {
  return request({
    url: '/goods/unreal/send',
    method: 'POST',
    data
  })
}

//虚拟商品发放获取验证码
export function sendVirtualGoodsCheckCode(id) {
  return request({
    url: `/goods/unreal/message/${ id }/v1`,
    method: 'PUT'
  })
}

//获取发放列表
export function getVirtualGoodsSendList(params) {
  return request({
    url: '/goods/unreal/send/v1',
    params
  })
}

//发放详情
export function getVirtualGoodsSendDetails(id, params) {
  return request({
    url: `/goods/unreal/send/${ id }`,
    params
  })
}

//发放列表批量作废
export function cancelSendVirtualGoodsBatch(data) {
  return request({
    url: `/goods/unreal/batch_delete/v1`,
    method: 'POST',
    data
  })
}

//发放列表详情作废
export function cancelSendVirtualGoodsDetails(id, data) {
  return request({
    url: `/mct_user_unreal/repeal/${ id }`,
    method: 'PUT',
    data
  })
}

//虚拟商品-导出发放数据
export function exportVirtualGoodsSendData(data) {
  return request(
    {
      url: `/export/unreal/send`,
      method: 'POST',
      data
    },
    {
      success: true,
      successMsg: $t('common.downloadBufferOK')
    }
  )
}

export function addBrandApi(data) {
  return request({
    url: `/goods_brand/add`,
    method: "POST",
    data,
  });
}

// 新增单位
export function addUnitApi(data) {
  return request({
    url: `/sys_dic/v1`,
    method: "POST",
    data,
  });
}

// 商户商品库导出
export function exportGoodsList(params) {
  return request({
    url: '/export/mct_goods/v1',
    params,
  });
}
